import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Spinner, Modal, Row } from 'react-bootstrap';
import { fetchConToken } from '../../api/fetch';
import { useForm } from '../../hooks/useForm';
import { useContextInfo } from '../../context/ContextInfo';
const initialState = {
    id: '',
    zona: '',
};
const MdZona = ({ show, onClose, zone, callBk }) => {
    const { setResp } = useContextInfo();
    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);

    const [values, handleInputChange, reset, setFormValue] = useForm({ ...initialState });
    const { id } = values;
    useEffect(() => {
        !show ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...zone });
    }, [show]);

    const funClose = () => {
        if (id) {
            onClose();
        } else {
            reset();
            onClose();
        }
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res;
            if (values.id.length !== 0) {
                res = await fetchConToken(`plus/zona/${id}`, values, 'PUT');
            } else {
                res = await fetchConToken('plus/zona', { ...values }, 'POST');
            }
            if (res.ok) {
                callBk();
                setResp(res);
                reset();
                funClose();
            }
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={funClose} size="kg">
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">{values.id.length !== 0 ? 'Editar' : 'Nueva'} Zona</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Nombre ubicación</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Ubicación"
                                                value={values.zona}
                                                name="zona"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default MdZona;
